import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const ktuinTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.ktuin,
  logoUrl: "https://cdn.nemuru.com/assets/logos/ktuin-logo.svg",
  palette: {
    primary: {
      main: "#ee0701",
      contrastText: "#FFF",
    },
    secondary: {
      main: "#000",
      light: "#000",
      contrastText: "#FFF",
    },
    text: {
      title: "#000",
      primary: "#333333",
      secondary: "#808080",
    },
    error: {
      light: "#fbefee",
      main: "#f1595c",
      contrastText: "#ffffff",
    },
    info: {
      main: "#00697c",
      contrastText: "#ffffff",
      light: "#eef5fd",
    },
    warning: {
      light: "#fefbf3",
      main: "#ffca28",
      contrastText: "#ffffff",
    },
    success: {
      light: "#f1faf1",
      main: "#1c8135",
      dark: "#033d12",
      contrastText: "#ffffff",
    },
    // additional colors
    dark: {
      main: "#f7f5f8",
      accent: "#ee0701",
      contrastText: "#000",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#1c8135",
      approved: "#033d12",
      analysing: "#00697c",
      sent: "#0041a5",
      cancelled: "#b6b5b2",
      denied: "#f1595c",
    },
    grey: {
      50: "#eeeeee",
      100: "#e8e8e8",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#fff",
  customBorderRadius: {
    button: 100,
    paper: 8,
    chip: 100,
  },
  typography: {
    fontFamily:
      '"SF Pro Display",-apple-system,system-ui,"Helvetica Neue",sans-serif',
  },
};
